import { Slice } from "gatsby"
import { useMemo } from "react"

import { Box } from "@mui/material"
import { FC } from ".."

const PreFooterSliceResolver: FC<{ id: string }> = ({ id }) => {
  const preFooterSlice = useMemo(() => {
    switch (id) {
      case "preFooterStyle1":
        return <Slice alias="preFooterStyle1" />
      case "preFooterStyle2":
        return <Slice alias="preFooterStyle2" />
      case "preFooterStyle3":
        return <Slice alias="preFooterStyle3" />
      case "preFooterStyle4":
        return <Slice alias="preFooterStyle4" />
      case "preFooterStyle5":
        return <Slice alias="preFooterStyle5" />
      case "preFooterStyle6":
        return <Slice alias="preFooterStyle6" />
      case "preFooterStyle7":
        return <Slice alias="preFooterStyle7" />
      default:
        return null
    }
  }, [])

  return <Box>{preFooterSlice}</Box>
}

export default PreFooterSliceResolver
